<form [formGroup]="filtersFormGroup" class="d-flex justify-content-between">
	<div style="width: 55%">
		<mat-form-field class="w-100" appearance="outline">
			<mat-label>Wyszukaj</mat-label>
			<input formControlName="q" type="text" matInput />
		</mat-form-field>

		<section class="d-flex flex-wrap">
			<mat-checkbox
				[checked]="!!filtersFormGroup.get('not_assigned').value"
				(change)="updateFormControlCheckboxValue($event, true)"
				[color]="checkboxColor"
				name="not_assigned"
				class="ps-2 w-50"
				>Nieprzypisane</mat-checkbox
			>
			<mat-checkbox
				[checked]="!!filtersFormGroup.get('watching').value"
				(change)="updateFormControlCheckboxValue($event, true)"
				name="watching"
				[color]="checkboxColor"
				class="pe-2 w-50"
				>Obserwowane</mat-checkbox
			>
			<mat-checkbox
				formControlName="table_name"
				name="table_name"
				(change)="updateFormControlCheckboxValue($event, 'reservation_reservation')"
				[color]="checkboxColor"
				class="ps-2 w-50"
				>Przypisane do rezerwacji</mat-checkbox
			>
			<mat-checkbox
				formControlName="labels__contains"
				name="labels__contains"
				[checked]="!!filtersFormGroup.get('labels__contains').value"
				(change)="updateLabelsArchiveValue($event.checked)"
				[color]="checkboxColor"
				class="pe-2 w-50"
				>Zarchiwizowane</mat-checkbox
			>
		</section>
		<div class="mt-3 submit-buttons">
			<button
				class="me-2"
				mat-raised-button
				color="primary"
				type="submit"
				[disabled]="filtersLoading"
				(click)="loadFilters()"
			>
				<mat-icon *ngIf="filtersLoading; else filtersLoaded"
					><mat-spinner diameter="20"> </mat-spinner
				></mat-icon>
				<ng-template #filtersLoaded>Pokaż</ng-template>
			</button>
			<button (click)="beforeClearFilters()" mat-raised-button>Wyczyść</button>
		</div>
	</div>
	<div style="width: 40%">
		<mat-form-field class="w-100" appearance="outline">
			<mat-label>Numer rezerwacji</mat-label>
			<input formControlName="table_id" type="number" matInput />
		</mat-form-field>
		<!--		<mat-form-field class="w-100" appearance="outline">-->
		<!--			<mat-label>Agent</mat-label>-->
		<!--			<input-->
		<!--				formControlName="seller"-->
		<!--				type="text"-->
		<!--				matInput-->
		<!--				[matAutocomplete]="seller"-->
		<!--			/>-->
		<!--			<mat-autocomplete-->
		<!--				[displayWith]="displayFn.bind(this)"-->
		<!--				#seller="matAutocomplete"-->
		<!--			>-->
		<!--				<mat-option [value]="seller.id" *ngFor="let seller of sellers"-->
		<!--					>{{ seller.name }}-->
		<!--				</mat-option>-->
		<!--			</mat-autocomplete>-->
		<!--		</mat-form-field>-->
	</div>
</form>
